/**
 * 🧱 Refactor BT Phase 3 — T1 : `useBtEditerHandlers` — code déplacé TEL QUEL depuis EditerBonTravailDialog.jsx
 * (ex-L697-778, avant T1) : handlers équipements / produits / étapes / zones (+ `handleZonePhotoUpload`).
 * `ctx` = noms du composant lus par ce code (mêmes valeurs de rendu qu'avant) ; retourne ce qu'il déclare.
 */
import { API_URL } from '../components/crm/bon-travail/utils';
import axios from 'axios';
import { toast } from 'sonner';

export function useBtEditerHandlers(ctx) {
  const {
    equipements,
    form,
    produits,
    setForm,
    setUploadingZone,
  } = ctx;

  // Équipements (extérieur)
  const addEquipement = (eqId) => {
    const eq = equipements.find(e => e.id === eqId);
    if (!eq || form.equipements_selectionnes.find(e => e.equipement_id === eqId)) return;
    
    // ✅ ÉTAPE 5 : Si c'est un échafaud, ajouter champs spécifiques
    const isEchafaud = eq.nom?.toLowerCase().includes('chafaud') || eq.emoji === '🪜';
    
    setForm(f => ({ ...f, equipements_selectionnes: [...f.equipements_selectionnes, {
      equipement_id: eq.id, 
      equipement_nom: eq.nom, 
      emoji: eq.emoji || '', 
      dates_utilisation: [...f.dates_chantier],
      nb_etages_utilises: 0, 
      apporter_lavage: false, 
      notes_lavage: '',
      // ✅ ÉTAPE 5 : Champs échafauds
      type: isEchafaud ? 'echafauds' : 'autre',
      type_etage: '',
      dimensions: '',
      date_montage: null,
      date_demontage: null,
      remorque_montage: 'bureau',  // 'bureau' ou 'client'
      remorque_demontage: 'bureau'
    }]}));
  };
  const removeEquipement = (idx) => setForm(f => ({ ...f, equipements_selectionnes: f.equipements_selectionnes.filter((_, i) => i !== idx) }));
  const toggleEquipDate = (eqIdx, dateStr) => {
    const updated = [...form.equipements_selectionnes];
    const eq = updated[eqIdx];
    eq.dates_utilisation = eq.dates_utilisation.includes(dateStr)
      ? eq.dates_utilisation.filter(d => d !== dateStr)
      : [...eq.dates_utilisation, dateStr].sort();
    setForm(f => ({ ...f, equipements_selectionnes: updated }));
  };

  // Produits
  const addProduit = () => setForm(f => ({ ...f, produits_selectionnes: [...f.produits_selectionnes, { produit_id: '', produit_nom: '', fini: '', unite: 'gallon', quantite: 1, quantite_prevue: 0, emplacement: '', code_couleur: '', commande_initiale_faite: false }] }));
  const updateProduit = (idx, field, value) => {
    const updated = [...form.produits_selectionnes];
    updated[idx] = { ...updated[idx], [field]: value };
    if (field === 'produit_id') {
      const p = produits.find(pr => pr.id === value);
      if (p) {
        updated[idx].produit_nom = p.nom;
        if (p.unite) updated[idx].unite = p.unite;
        const finis = p.finis_disponibles || p.finis || [];
        if (finis.length === 1) updated[idx].fini = finis[0];
        else if (finis.length === 0) updated[idx].fini = '';
      }
    }
    setForm(f => ({ ...f, produits_selectionnes: updated }));
  };
  const removeProduit = (idx) => setForm(f => ({ ...f, produits_selectionnes: f.produits_selectionnes.filter((_, i) => i !== idx) }));

  // Étapes
  const addEtape = () => setForm(f => ({ ...f, etapes: [...f.etapes, { numero: f.etapes.length + 1, description: '', completee: false }] }));
  const updateEtape = (idx, desc) => { const u = [...form.etapes]; u[idx] = { ...u[idx], description: desc }; setForm(f => ({ ...f, etapes: u })); };
  const removeEtape = (idx) => setForm(f => ({ ...f, etapes: f.etapes.filter((_, i) => i !== idx).map((e, i) => ({ ...e, numero: i + 1 })) }));

  // Zones
  const addZone = () => setForm(f => ({ ...f, zones: [...f.zones, { numero: f.zones.length + 1, nom: '', description: '', photo_url: null }] }));
  const updateZone = (idx, field, value) => { const u = [...form.zones]; u[idx] = { ...u[idx], [field]: value }; setForm(f => ({ ...f, zones: u })); };
  const removeZone = (idx) => setForm(f => ({ ...f, zones: f.zones.filter((_, i) => i !== idx).map((z, i) => ({ ...z, numero: i + 1 })) }));

  const handleZonePhotoUpload = async (idx, file) => {
    setUploadingZone(idx);
    try {
      const { compressImageIfNeeded } = await import('@/lib/imageCompression');
      const compressed = await compressImageIfNeeded(file);
      const formData = new FormData();
      formData.append('file', compressed);
      const res = await axios.post(`${API_URL}/api/crm/upload-photo`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res.status !== 200) throw new Error('Upload failed');
      const data = res.data;
      updateZone(idx, 'photo_url', data.photo_url);
      toast.success('Photo uploadée');
    } catch (e) { toast.error('Erreur upload'); }
    finally { setUploadingZone(null); }
  };

  return { addEquipement, addEtape, addProduit, addZone, handleZonePhotoUpload, removeEquipement, removeEtape, removeProduit, removeZone, toggleEquipDate, updateEtape, updateProduit, updateZone };
}
